export function convertToLocalString(date: Date): string {
  let dateStr = date.toLocaleDateString();
  let elements = dateStr.split('.').map(e => '0' + e.trim());
  dateStr = [
    elements[0].substr(elements[0].length - 4),
    elements[1].substr(elements[1].length - 2),
    elements[2].substr(elements[2].length - 2)
  ].join('-');
  return dateStr;
}

export function convertToTimeString(date: Date): string {
  var d = new Date(date);
  // d.setMinutes(d.getMinutes() + new Date().getTimezoneOffset());
  var hour = '' + d.getHours();
  var min = '' + d.getMinutes();

  if (hour.length < 2) {
    hour = `0${hour}`;
  }
  if (min.length < 2) {
    min = `0${min}`;
  }
  return [hour, min].join(':');
}

// export function convertToParamString(date: Date): string {
//   date.setMinutes(date.getMinutes() - new Date().getTimezoneOffset());
//   const result = convertToLocalString(date);
//   return result;
// }

// export function convertToParamDate(date: Date): Date {
//   date.setMinutes(date.getMinutes() - new Date().getTimezoneOffset());
//   return date;
// }

export function parseDate(dateStr: string): Date {
  let elements = dateStr.split('-');
  let year = parseInt(elements[0]);
  let month = parseInt(elements[1]) - 1;
  let date = parseInt(elements[2]);
  return new Date(year, month, date);
}

export function mergeDateTime(date: Date, time: string): Date {
  date = new Date(date);
  let elements = time.split(':');
  date.setHours(parseInt(elements[0]), parseInt(elements[1]));
  return date;
}